export default __webpack_public_path__ + "static/media/loop1.d386cfa1.png";